// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no_record_fullbox {
  height: 350px;
}

.report_box_row {
  margin-top: 20px;
  align-items: start;
}

.compare_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.compare_box label {
  font-size: 12px;
}

.react-datepicker-wrapper {
  width: 100%;
}
.react-datepicker-wrapper .react-datepicker__input-container input {
  font-size: 1rem;
  padding: 0.65rem 0.9rem !important;
  border-color: hsl(0, 0%, 80%);
  border-radius: 4px;
  border-style: solid;
  border-width: 1px;
  min-height: 38px;
  color: hsl(0, 0%, 20%);
  width: 100%;
}

.dashcheckMainBox {
  align-items: center;
  justify-content: start;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #d9ebea;
  border: 1px solid #d9ebea;
  border-radius: 5px;
}
.dashcheckMainBox .dashcheckBox label {
  display: inline-flex;
  align-items: center;
}
.dashcheckMainBox .dashcheckBox label input {
  width: 20px;
  height: 20px;
}
.dashcheckMainBox .dashcheckBox label p {
  margin-bottom: 0;
  margin-left: 10px;
  font-size: 14px;
}
.dashcheckMainBox .dashcheckBox .css-1jqq78o-placeholder {
  font-size: 13px;
}
.dashcheckMainBox .dashcheckBox .css-1dimb5e-singleValue {
  font-size: 13px;
}
.dashcheckMainBox .dashcheckBox.with_button {
  display: flex;
  justify-content: end;
}
.dashcheckMainBox .dashcheckBox.with_button button {
  width: 18%;
  padding: 10px;
}
@media only screen and (max-width: 768px) {
  .dashcheckMainBox {
    flex-wrap: wrap;
  }
  .dashcheckMainBox .dashcheckBox {
    width: 100%;
    margin-bottom: 10px;
  }
  .dashcheckMainBox .dashcheckBox:last-child {
    margin-bottom: 0;
  }
  .dashcheckMainBox .dashcheckBox:last-child button {
    width: 100%;
  }
  .dashcheckMainBox .dashcheckBox label p {
    font-size: 14px;
  }
}

.v_imagemainbox {
  margin-top: 23px;
}
.v_imagemainbox .v_imagebox {
  display: flex;
  justify-content: start;
  align-items: center;
}
.v_imagemainbox .v_imagebox i {
  font-size: 18px;
  margin-left: 10px;
}
.v_imagemainbox .dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 32px rgba(0, 0, 0, 0.11);
  border: 1px solid #dadce0;
  border-radius: 8px;
}
.v_imagemainbox .dialog button {
  width: 25px;
  height: 25px;
  border: 1px solid #dadce0;
  color: #000;
  position: absolute;
  top: 10px;
  right: 10px;
  border-radius: 25px;
}

.dashboard__right select {
  padding: 8px 20px 8px 4px;
  border: 1px solid #ccc;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/styles/mixed.scss"],"names":[],"mappings":"AAAA;EAAmB,aAAA;AAEnB;;AADA;EACI,gBAAA;EACA,kBAAA;AAIJ;;AAFA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;AAKJ;AAHI;EACI,eAAA;AAKR;;AADA;EAEI,WAAA;AAGJ;AAAQ;EACI,eAAA;EACA,kCAAA;EACA,6BAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;AAEZ;;AAGA;EAEI,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;AADJ;AAQQ;EACI,oBAAA;EACA,mBAAA;AANZ;AAQY;EACI,WAAA;EACA,YAAA;AANhB;AASY;EACI,gBAAA;EACA,iBAAA;EACA,eAAA;AAPhB;AAWQ;EACI,eAAA;AATZ;AAWQ;EACI,eAAA;AATZ;AAWQ;EACI,aAAA;EACA,oBAAA;AATZ;AAWY;EACI,UAAA;EACA,aAAA;AAThB;AAcI;EAhDJ;IAiDQ,eAAA;EAXN;EAaM;IACI,WAAA;IACA,mBAAA;EAXV;EAaU;IACI,gBAAA;EAXd;EAac;IACI,WAAA;EAXlB;EAgBc;IACI,eAAA;EAdlB;AACF;;AAoBA;EACI,gBAAA;AAjBJ;AAmBI;EAEI,aAAA;EACA,sBAAA;EACA,mBAAA;AAlBR;AAoBQ;EACI,eAAA;EACA,iBAAA;AAlBZ;AAwBI;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,wCAAA;EACA,yBAAA;EACA,kBAAA;AAtBR;AAwBQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAtBZ;;AA6BI;EACI,yBAAA;EACA,sBAAA;EACA,kBAAA;AA1BR","sourcesContent":[".no_record_fullbox{height: 350px;}\n.report_box_row{\n    margin-top: 20px;\n    align-items: start;\n}\n.compare_box{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    label{\n        font-size: 12px;\n    }\n\n}\n.react-datepicker-wrapper{\n\n    width: 100%;\n    \n    .react-datepicker__input-container{\n        input{\n            font-size: 1rem;\n            padding: 0.65rem 0.9rem !important;\n            border-color: hsl(0, 0%, 80%);\n            border-radius: 4px;\n            border-style: solid;\n            border-width: 1px;\n            min-height: 38px;\n            color: hsl(0, 0%, 20%);\n            width: 100%;\n        }\n    }\n}\n\n.dashcheckMainBox{\n    // display: flex;\n    align-items: center;\n    justify-content: start;\n    margin-bottom: 20px;\n    padding: 15px;\n    background-color: #d9ebea;\n    border: 1px solid #d9ebea;\n    border-radius: 5px;\n\n    \n\n    .dashcheckBox{\n        // width: calc(100%/3);\n\n        label{\n            display: inline-flex;\n            align-items: center;\n\n            input{\n                width: 20px;\n                height: 20px;\n            }\n\n            p{\n                margin-bottom: 0;\n                margin-left: 10px;\n                font-size: 14px;\n            }\n            \n        }\n        .css-1jqq78o-placeholder {\n            font-size: 13px;\n        }\n        .css-1dimb5e-singleValue {\n            font-size: 13px;\n        }\n        &.with_button{\n            display: flex;\n            justify-content: end;\n\n            button{\n                width: 18%;\n                padding: 10px;\n            }\n        }\n    }\n\n    @media only screen and (max-width: 768px){\n        flex-wrap: wrap;\n\n        .dashcheckBox{\n            width: 100%;\n            margin-bottom: 10px;\n\n            &:last-child{\n                margin-bottom: 0;\n\n                button{\n                    width: 100%;\n                }\n            }\n\n            label{\n                p{\n                    font-size: 14px;\n                }\n            }  \n        }\n    }\n}\n\n.v_imagemainbox{\n    margin-top: 23px;\n\n    .v_imagebox{\n\n        display: flex;\n        justify-content: start;\n        align-items: center;\n\n        i{\n            font-size: 18px;\n            margin-left: 10px;\n        }\n    }\n\n    \n\n    .dialog{\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%,-50%);\n        width: 400px;\n        height: 400px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        box-shadow: 0 0 32px rgba(0,0,0,.11);\n        border: 1px solid #dadce0;\n        border-radius: 8px;\n    \n        button{\n            width: 25px;\n            height: 25px;\n            border: 1px solid #dadce0;\n            color: #000;\n            position: absolute;\n            top: 10px;\n            right: 10px;\n            border-radius: 25px;\n        }\n    }\n}\n\n\n.dashboard__right{\n    select{\n        padding: 8px 20px 8px 4px;\n        border: 1px solid #ccc;\n        border-radius: 4px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
